<div class="container mb-4">
  <div class="row"><div class="col-12"><h3 style="color:#719eb6">BIPs</h3></div></div>

  <div class="row g-3">
    <div class="col-12" *ngIf="loading()">
      <div class="d-flex justify-content-center py-5">
        <div class="spinner-border text-primary" role="status" aria-label="Loading">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!loading()">
      <ng-container *ngIf="rows()?.length; else emptyState">
        @for (item of rows(); track item.ID) {
          <div class="col-12">
            <div class="p-3 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between" style="border: 2px solid #e1e8fb; border-radius: 10px; background-color: #e1e8fb;">
              <div class="mb-3 mb-md-0">
                <div class="d-flex align-items-center gap-2">
                    <span *ngIf="item.IsCurrent" class="badge rounded-pill bg-success position-relative" title="Current">C</span>
                    <span *ngIf="!item.SignedDate" class="badge rounded-pill bg-secondary position-relative" title="Draft">D</span>
                  <h5 class="mb-1" style="color:#222;">BIP #{{item.ID}}
                  
                </h5>
                </div>
                <div class="text-muted small">
                  <span class="me-3">Created: {{item.CreatedDate | date:'short'}}</span>
                  <span>Signed: {{item.SignedDate ? (item.SignedDate | date:'short') : '—'}}
                  </span>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <button class="btn btn-sm btn-outline-primary" (click)="openPdf(item)">View PDF</button>
                <button class="btn btn-sm btn-success" *ngIf="canEditBip && !item.SignedDate" (click)="finish(item)">Finish & Sign</button>
              </div>
            </div>
          </div>
        }
      </ng-container>

      <ng-template #emptyState>
        <div class="col-12">
          <div class="text-center text-muted py-5" style="border: 2px dashed #e1e8fb; border-radius: 10px;">
            No BIPs available.
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <p-dialog header="Preview BIP" [(visible)]="previewVisible" [modal]="true" [style]="{width:'80vw'}">
    <div class="d-flex align-items-center" *ngIf="!previewBlob">
        <div class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
        <span>Loading BIP...</span>
      </div>
    <div *ngIf="previewBlob" style="width: 100%; height: 70vh">
      <ng2-pdfjs-viewer [pdfSrc]="previewBlob" [print]="false"
      [download]="true"
      [fullScreen]="false"
      [viewBookmark]="false"
      [openFile]="false"
      [page]="1"></ng2-pdfjs-viewer>
    </div>
  </p-dialog>

<p-dialog header="Finish & Sign BIP" [(visible)]="signVisible" [modal]="true" [style]="{width:'80vw'}">
  <div class="row g-3">
    <div class="col-12 col-lg-7">
      <label class="fw-bold">Preview</label>
      <div class="d-flex align-items-center" *ngIf="!previewBlob">
        <div class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
        <span>Loading BIP...</span>
      </div>
      <div *ngIf="previewBlob" style="width: 100%; height: 70vh">
        <ng2-pdfjs-viewer [pdfSrc]="previewBlob" [print]="false"
      [download]="true"
      [fullScreen]="false"
      [viewBookmark]="false"
      [openFile]="false"
      [page]="1"></ng2-pdfjs-viewer>
      </div>
    </div>
    <div class="col-12 col-lg-5">
      <label class="fw-bold">Sign as</label>
      <div class="mt-1">
        <div class="mb-2"><strong>{{ userName }}</strong></div>
        <img *ngIf="signatureUrl" [src]="signatureUrl" alt="Signature" style="max-width: 100%; max-height: 120px;" />
      </div>
      <div class="mt-3">
        <div *ngIf="signing" class="mb-2">
          <div class="d-flex align-items-center">
            <div class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
            <span>Signing BIP...</span>
          </div>
        </div>
        <button class="btn btn-sm btn-primary" [disabled]="!previewBlob || signing" (click)="confirmSign()">Confirm</button>
      </div>
    </div>
  </div>
</p-dialog>
</div>


